import { render, staticRenderFns } from "./news4.vue?vue&type=template&id=3fc52008&scoped=true"
import script from "./news4.vue?vue&type=script&lang=js"
export * from "./news4.vue?vue&type=script&lang=js"
import style0 from "./news4.vue?vue&type=style&index=0&id=3fc52008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc52008",
  null
  
)

export default component.exports